<mat-divider></mat-divider>
<footer>
  <p>&copy; 2022 REELIH - Habitat for Humanity Macedonia, <a href="mailto:{{ mailTo }}"><span>{{ mailTo }}</span></a>
  </p>
</footer>
